import React from 'react';

import logo from 'components/shared/LogoImage/logo.png';
import { APP_NAME } from 'constants/views';

const LogoImage = (props) => <img alt={APP_NAME} {...props} src={logo} />;

export default LogoImage;
